<template>
  <van-popup
    v-if="data"
    :close-on-click-overlay="false"
    :value="visible"
    position="top"
    :style="{ top: top + 'px' }"
  >
    <div class="notice-title" v-html="data.title"></div>
    <div
      class="notice-content"
      v-html="data.content && escape2Html(data.content)"
    ></div>
    <div class="notice-ok-btn" @click="handleNotice">
      {{ $t("im.我知道了") }}
    </div>
  </van-popup>
</template>

<script>
import { escape2Html } from "@/utils/util";

export default {
  name: "ImNotice",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    top: {
      type: Number,
      default: 0,
    },
  },
  watch: {},
  data() {
    return {
      timer: null,
      timeNum: 0,
    };
  },
  methods: {
    escape2Html,
    initData() {
      const timeNum = (this.data && this.data.wait_time) || 0;
      this.timeNum = timeNum;
      if (timeNum && timeNum > 0) {
        this.setTimer();
      }
    },
    handleNotice() {
      this.$emit("close");
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.timeNum = this.timeNum - 1;
        if (this.timeNum <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.notice-title {
  font-size: 16px;
  padding: 10px;
}

.notice-date {
  padding: 0 10px;
  color: #999;
  font-size: 12px;
}

.notice-content {
  padding: 10px;
  color: #666;
  font-size: 14px;
  height: 25vh;
  .scrollMinXin(hidden, auto);
}

.notice-ok-btn {
  width: 100%;
  height: 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid #f7f7f7;
  color: @gold;
}
</style>
